<template>
  <img
    class="h-14 w-14 animate-bounce"
    src="/images/logo-icon.png"
    alt="loading"
  />
</template>
